module.exports = __webpack_public_path__ + "static/media/extrait_retour_utilisateurs.73178914.pdf";